import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { fetchMarketsWheel, fetchMarkets, setVal, changeValue } from '../../actions';
import { splitLines, sectorDetails } from '../../helpers/Utils';

class MarketWheelMobile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            marketLists: [], //this.props.marketswheel,
            width: 200,
            titleControl: "Chart-title",
            selectedControl: "Chart-title",
            innerTextline1: "Select A",
            innerTextline2: "Cycle Position To",
            innerTextline3: "View Markets"

        };

        this.OnPositionClick = this.OnPositionClick.bind(this);

    }

    renderTitle() {
        return this.props.period;
    }
    renderMarketName()
    {
      let { marketselected } = this.props;      
      let lineHeight = 0.15;
      let textFont = "15px futura-pt";

      if(marketselected.length >15)
      {
        return splitLines(marketselected, textFont, 120, lineHeight, 50)
      }
      else
      {
        return marketselected;
      }
  
    }
  
    renderRegion() {
        let { region } = this.props;
        let regionDisplay = region;
        if (region === "Global") {
            regionDisplay = "Key Global";
        } 
        return regionDisplay;
    }
    renderAreaOnCycle()
    {
      let { marketselected } = this.props;
      let areaOnCycle ='';
      this.props.marketswheel.forEach(element => {
  
        if ((element.market) === marketselected.trim()) {
          if (element.market.length > 0) {
            areaOnCycle= element.areaOnCycle;
        }
  
        }
      });
      let lineHeight = 1.30;
      let textFont = "15px futura-pt";
      if(areaOnCycle.length >30)
      {
          return splitLines(areaOnCycle, textFont, 180, lineHeight,60);
      }
      else
      {
        return areaOnCycle;
      }
      
    }

    componentDidMount() {
        this.props.fetchMarketsWheel();
        this.props.fetchMarkets();
        const position = parseInt(this.props.selectedWheelPosition)
        const { sectorText, sectorColor } = sectorDetails(position);
        if(this.props.selectedDefinition){
            if (this.props.selectedDefinition === 0) {    
                this.props.hideCities();
            }
            else {
                this.props.displayCities(sectorText, position, sectorColor);
            }

              // This code is to set the background color of the inner circle as we navigate back from detail page.
                if(this.props.selectedWheelPosition !== 0)
                {
                   var sectordetails = sectorDetails(this.props.selectedWheelPosition)
                
                   //let marketbg = document.getElementById('Market-Info-background');
                   let marketbg = document.getElementById('Market-Info');

                   if(marketbg)
                   {
                   marketbg.setAttribute("fill", sectordetails.sectorColor);
                   }
        
                }

        }


  
    }

    
    OnPositionClick(e, position, sectorText, sectorColor) {
   
      this.setState({toggleIcon:false, innerTextline2: "Market To View", innerTextline3: "More Details"});
      
      let currentSelection = parseInt(e.target.id.match(/\d/)[0]);
     // let updatedSelection = (currentSelection === this.props.selectedDefinition ? 0 : currentSelection);
        // Testing the search functionality when we are in same position
       let updatedSelection = currentSelection  ? currentSelection: 0;
      
      this.props.setVal(updatedSelection, updatedSelection)
      this.props.setMarket('', 0);

      if(position) {
    
        if (updatedSelection === 0) {
           
            this.props.hideCities();
        }
        else {
         
            if (this.props.displayCities) {
                this.props.displayCities(sectorText, position, sectorColor);
            }
        }
    }
     e.stopPropagation();
    }

    render() {
        let { marketswheel, region, period } = this.props;
        let positions = []; // positions which has markets
        positions = marketswheel.map(eachObject => {
            if((eachObject.greaterRegion === region || (region === 'Global' && eachObject.isGlobal)) 
            && eachObject.period === period) {
                return eachObject.position;
            }
            return null;
        });
        return (
<svg width="344" height="344" viewBox="0 0 344 344" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="Main - Mobile">
      <path d="M343 172C343 202.017 335.099 231.505 320.09 257.5C305.082 283.495 283.495 305.082 257.5 320.09L213.22 243.394C225.752 236.159 236.159 225.752 243.394 213.22C250.63 200.687 254.439 186.471 254.439 172H343Z" fill="#CAD1D3" stroke="white" stroke-width="2" id="Position-3-sector-mobile" onClick={(e) => this.OnPositionClick(e, 3, 'Rent Decline Slowing', '')}  className={`${this.props.selectedWheelPosition === 3 ? "rent-position-on-mobile" : "rent-position-off-mobile"}`}  />
      <path d="M257.5 23.9096C283.495 38.918 305.082 60.5047 320.09 86.5C335.099 112.495 343 141.983 343 172L254.439 172C254.439 157.529 250.63 143.313 243.394 130.78C236.159 118.248 225.752 107.841 213.22 100.606L257.5 23.9096Z" fill="#CAD1D3" stroke="white" stroke-width="2" id="Position-2-sector-mobile" onClick={(e) => this.OnPositionClick(e, 2, 'Rent Decline Accelerating', '')}   className={`${this.props.selectedWheelPosition === 2 ? "rent-position-on-mobile" : "rent-position-off-mobile"}`}  />
      <path d="M86.5 23.9096C112.495 8.90126 141.983 0.999992 172 1C202.017 1.00001 231.505 8.90129 257.5 23.9097L213.22 100.606C200.687 93.3701 186.471 89.5609 172 89.5609C157.529 89.5609 143.313 93.3701 130.78 100.606L86.5 23.9096Z" fill="#CAD1D3" stroke="white" stroke-width="2" id="Position-1-sector-mobile" onClick={(e) => this.OnPositionClick(e, 1, 'Rents at Peak', '')}  className={`${this.props.selectedWheelPosition === 1 ? "rent-position-on-mobile" : "rent-position-off-mobile"}`} />	  
      <path d="M1 172C1 141.983 8.90129 112.495 23.9097 86.4999C38.9181 60.5046 60.5048 38.9179 86.5002 23.9096L130.781 100.606C118.248 107.841 107.841 118.248 100.606 130.78C93.3701 143.313 89.5609 157.529 89.5609 172L1 172Z" fill="#CAD1D3" stroke="white" stroke-width="2" id="Position-6-sector-mobile" onClick={(e) => this.OnPositionClick(e, 6, 'Rent Growth Slowing', '')}   className={`${this.props.selectedWheelPosition === 6 ? "rent-position-on-mobile" : "rent-position-off-mobile"}`} />
      <path d="M86.5 320.09C60.5047 305.082 38.918 283.495 23.9096 257.5C8.90119 231.505 0.999947 202.017 1 172L89.5609 172C89.5609 186.471 93.3701 200.687 100.606 213.219C107.841 225.752 118.248 236.159 130.78 243.394L86.5 320.09Z" fill="#CAD1D3" stroke="white" stroke-width="2" id="Position-5-sector-mobile" onClick={(e) => this.OnPositionClick(e, 5, 'Rent Growth Accelerating', '')}   className={`${this.props.selectedWheelPosition === 5 ? "rent-position-on-mobile" : "rent-position-off-mobile"}`} />     
	    <path d="M257.5 320.09C231.505 335.099 202.017 343 172 343C141.983 343 112.495 335.099 86.4998 320.09L130.78 243.394C143.313 250.63 157.529 254.439 172 254.439C186.471 254.439 200.687 250.63 213.22 243.394L257.5 320.09Z" fill="#CAD1D3" stroke="white" stroke-width="2" id="Position-4-sector-mobile" onClick={(e) => this.OnPositionClick(e, 4, 'Rents at Trough', '')}   className={`${this.props.selectedWheelPosition === 4 ? "rent-position-on-mobile" : "rent-position-off-mobile"}`} />
    
	  <text id="Position-1-title-mobile" onClick={(e) => this.OnPositionClick(e, 1, 'Rents at Peak', '')} fill="#ffffff" xmlSpace="preserve" 
      font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em">
        <tspan id = "Position-1-title-1-mobile" x="133" y="51.1" onClick={(e) => this.OnPositionClick(e, 1, 'Rents at Peak', '')}>Rents at Peak</tspan>
      </text>
	  
      <text id="Position-2-title-mobile"  onClick={(e) => this.OnPositionClick(e, 2, 'Rent Decline Accelerating', '#007554')} fill="#ffffff" xmlSpace="preserve" font-family="Calibre" 
      font-size="14" font-weight="500" letter-spacing="0em">
        <tspan id = "Position-2-title-1-mobile" x="255" y="102.1" onClick={(e) => this.OnPositionClick(e, 2, 'Rent Decline Accelerating', '#007554')}>Rent </tspan>
        <tspan id = "Position-2-title-1-mobile" x="255" y="116.1" onClick={(e) => this.OnPositionClick(e, 2, 'Rent Decline Accelerating', '#007554')}>Decline </tspan>
        <tspan id = "Position-2-title-1-mobile" x="255" y="130.1" onClick={(e) => this.OnPositionClick(e, 2, 'Rent Decline Accelerating', '#007554')}>Accelerating</tspan>
      </text>
      <text id="Position-3-title-mobile" onClick={(e) => this.OnPositionClick(e, 3, 'Rent Decline Slowing', '#75116a')} fill="#ffffff" xmlSpace="preserve" font-family="Calibre" 
      font-size="14" font-weight="500" letter-spacing="0em">
        <tspan id="Position-3-title-1-mobile" x="260" y="222.1" onClick={(e) => this.OnPositionClick(e, 3, 'Rent Decline Slowing', '#75116a')}>Rent </tspan>
        <tspan id="Position-3-title-1-mobile" x="260" y="236.1" onClick={(e) => this.OnPositionClick(e, 3, 'Rent Decline Slowing', '#75116a')}>Decline </tspan>
        <tspan id="Position-3-title-1-mobile" x="260" y="250.1" onClick={(e) => this.OnPositionClick(e, 3, 'Rent Decline Slowing', '#75116a')}>Slowing</tspan>
      </text>
      <text id="Position-4-title-mobile" onClick={(e) => this.OnPositionClick(e, 4, 'Rents at Trough', '#bc006f')} fill="#ffffff" xmlSpace="preserve" font-family="Calibre" 
      font-size="14" font-weight="500" letter-spacing="0em">
        <tspan id="Position-4-title-1-mobile" x="125" y="299.1" onClick={(e) => this.OnPositionClick(e, 4, 'Rents at Trough', '#bc006f')}>Rents at Trough</tspan>
      </text>
      <text id="Position-6-title-mobile"  onClick={(e) => this.OnPositionClick(e, 6, 'Rent Growth Slowing', '#99b133')} fill="#ffffff" xmlSpace="preserve" font-family="Calibre" 
      font-size="14" font-weight="500" letter-spacing="0em">
        <tspan id="Position-6-title-1-mobile" x="39" y="102.1" onClick={(e) => this.OnPositionClick(e, 6, 'Rent Growth Slowing', '#99b133')}>Rent </tspan>
        <tspan id="Position-6-title-1-mobile" x="39" y="116.1" onClick={(e) => this.OnPositionClick(e, 6, 'Rent Growth Slowing', '#99b133')}>Growth </tspan>
        <tspan id="Position-6-title-1-mobile" x="39" y="130.1" onClick={(e) => this.OnPositionClick(e, 6, 'Rent Growth Slowing', '#99b133')}>Slowing</tspan>
      </text>
	  
      <text id="Position-5-title-mobile"  onClick={(e) => this.OnPositionClick(e, 5, 'Rent Growth Accelerating', '#cb630b')} fill="#ffffff" xmlSpace="preserve" 
      font-family="Calibre" font-size="14" font-weight="500" letter-spacing="0em">
        <tspan id="Position-5-title-1-mobile" x="37" y="222.1" onClick={(e) => this.OnPositionClick(e, 5, 'Rent Growth Accelerating', '#cb630b')}>Rent </tspan>
        <tspan id="Position-5-title-1-mobile" x="37" y="236.1" onClick={(e) => this.OnPositionClick(e, 5, 'Rent Growth Accelerating', '#cb630b')}>Growth </tspan>
        <tspan id="Position-5-title-1-mobile" x="37" y="250.1" onClick={(e) => this.OnPositionClick(e, 5, 'Rent Growth Accelerating', '#cb630b')}>Accelerating</tspan>
      </text>
	  
      <g id="Chart-title" className={`${this.props.selectedDefinition === 0 || this.props.selectedDefinition === 1  || this.props.selectedDefinition === 2 || this.props.selectedDefinition === 3 || this.props.selectedDefinition === 4
           || this.props.selectedDefinition === 5 || this.props.selectedDefinition === 6  ? "show-element market-wheel-inside-default-text" : "hide-element"}`}>
        <text id="Select a cycle position to view markets" fill="#435254" xmlSpace="preserve" font-family="Calibre" font-size="16" letter-spacing="0em">
          <tspan x="129.578" y="159.4">{this.state.innerTextline1}</tspan>
          <tspan x="123.367" y="181.4">{this.state.innerTextline2}</tspan>
          <tspan x="147" y="203.4">{this.state.innerTextline3}</tspan>
        </text>
      </g>
  </g>
</svg>

  );}
}

const mapStateToProps = (state) => {

    return {
        period: state.activePeriod,
        region: state.greaterRegions,
        marketswheel: state.marketswheel,
        selectedDefinition: state.selectedWheelPosition.selectedDefinition,
        selectedWheelPosition: state.selectedWheelPosition.selectedWheelPosition,
        marketselected: state.marketselected,
        basepath : state.basepath
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
        fetchMarketsWheel : () =>{
          dispatch(fetchMarketsWheel())
        },
      fetchMarkets: () => {
        dispatch(fetchMarkets())
        },
      setMarket: (marketid, positionid) => {
        dispatch(changeValue(marketid, positionid))
        },
      setVal: (selectedDefinition, selectedPosition ) => {
        dispatch(setVal(selectedDefinition, selectedPosition))
        }  
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MarketWheelMobile);
